import { Dispatch, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProductPageAdditionalInfo } from './actions';
import { getProductPageReviewSummary } from 'views/ProductPage/reviews/themes/BGH/actions';
import { withCurrentPage } from 'utils';
import { getProductId, siteModeSelector } from 'views/ProductPage/selector';

export const useLoadAdditionalData = () => {
  const dispatch = useDispatch();
  const productId = useSelector(withCurrentPage(getProductId));
  const siteMode = useSelector(siteModeSelector);

  useEffect(() => {
    loadAdditionalData(dispatch);
    loadReviewSummary(dispatch);
  }, [productId, siteMode, dispatch]);
};

function loadAdditionalData(dispatch: Dispatch<unknown>) {
  dispatch(getProductPageAdditionalInfo());
}

function loadReviewSummary(dispatch: Dispatch<unknown>) {
  dispatch(getProductPageReviewSummary());
}
